import { CustomPipeSeries } from "@src/core/api/customPipeSeries";
import { normalizeCustomSeries } from "@src/core/engine/pipes/normalizeCustomSeries";
import { pipesRepository } from "@src/core/engine/pipes/pipesRepository";

export function getSeriesDefaultPipe(
  seriesId: string | null | undefined,
  customPipeSeries: CustomPipeSeries[],
) {
  if (!seriesId) return null;
  const allSeries = [
    ...normalizeCustomSeries(customPipeSeries),
    ...pipesRepository.getAllPipeSeries(),
  ];
  const selectedSeries = allSeries.find((series) => series.id === seriesId);
  return selectedSeries?.defaultPipe.id ?? null;
}
